<ng-content *ngIf="screen.width < 1100; then mobile else desktop"></ng-content>

<ng-template #mobile>
    <new-contact-mobile (save)="onSave($event)"></new-contact-mobile>
</ng-template>

<ng-template #desktop>
    <new-contact-desktop (save)="onSave($event)"></new-contact-desktop>

</ng-template>